import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import AmericanAboutBox from "components/company/v3/american/boxes/AmericanAboutBox";
import AmericanCardsContent from "components/company/v3/american/contents/about/AmericanCardsContent";
import AmericanPageLayout from "components/company/v3/layouts/AmericanPageLayout";
import { CompanyAboutTabEnum } from "components/company/v3/menu/enums";
import AmericanIssuerSeo from "components/company/v3/seo/AmericanIssuerSeo";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import NotFound from "pages/404";
import { useIntl } from "react-intl";
import { format } from "util";

interface AmericanAboutPageProps {
  tickerSymbol: string | null;
}

const AmericanAboutPage: NextPage<AmericanAboutPageProps> = function AmericanAboutPage({ tickerSymbol }) {
  const intl = useIntl();
  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <AmericanPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab
        category="Stocks"
        tab={CompanyAboutTabEnum.ABOUT}
        tickerSymbol={normalizedTickerSymbol}
      >
        <AmericanAboutBox key={format("about/%s/%s", normalizedTickerSymbol)} tickerSymbol={normalizedTickerSymbol}>
          <AmericanIssuerSeo
            title={intl.formatMessage({
              defaultMessage: "Sobre",
              description: "Título da página - SEO",
              id: "nicxtA",
            })}
          />
          <AmericanCardsContent />
        </AmericanAboutBox>
      </WrapperAmplitudeCompanyTab>
    </AmericanPageLayout>
  );
};

AmericanAboutPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default AmericanAboutPage;
